import { render, staticRenderFns } from "./OnboardingUserInfo.vue?vue&type=template&id=fc489de2&"
import script from "./OnboardingUserInfo.vue?vue&type=script&lang=ts&"
export * from "./OnboardingUserInfo.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports